import { FC } from 'react'

const Menu: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M 3 20 L 21 20 L 21 18 L 3 18 L 3 20 Z M 9 13 L 21 13 L 21 11 L 9 11 L 9 13 Z M 3 6 L 21 6 L 21 4 L 3 4 L 3 6 Z'
        fill={fill || '#1D1D1F'}
        style={{ transformBox: 'fill-box', transformOrigin: '50% 50%' }}
        transform='matrix(-1, 0, 0, -1, 0.000001, 0.000001)'
      />
    </svg>
  )
}

export default Menu
